import type {
  ClientLoaderFunctionArgs,
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { FeaturedRouteComponent } from '@jane/bloom/components/routes/featured/featuredRouteComponent';
import featuredStylesLink from '@jane/bloom/components/routes/featured/styles.css?url';
import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { reset } from '@jane/bloom/loaders/clientLoader/storage';
import { loadFeaturedRoute } from '@jane/bloom/loaders/routes/featured.server';
import { featuredRouteMeta } from '@jane/bloom/resources/meta/routes/featured';
import { plpStylesLinks } from '@jane/bloom/resources/plpStylesLinks';
import { hasAnyFiltersApplied } from '@jane/bloom/viewModels/filters/utils';

export const links: LinksFunction = () => [
  { href: featuredStylesLink, rel: 'stylesheet' },
  ...plpStylesLinks,
];

export const meta: MetaFunction<typeof loader> = (args) => {
  return featuredRouteMeta(args);
};

export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();

  if (!hasAnyFiltersApplied(serverLoader.searchCriteria)) {
    reset();
  }

  if (serverLoader.viewMode === 'featured') {
    return serverLoader;
  }

  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export const loader = async (args: LoaderFunctionArgs) =>
  loadFeaturedRoute({ args, shouldPinStore: true });

export default function MenuRoute() {
  return <FeaturedRouteComponent />;
}
